import React, { useEffect, useState } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../Markdown/markdownComponents";
import "../Style/services.css";
import { fetchAndDisplayText } from "./ReadAndFetchText";
import { CASE_STUDIES_BY_SLUG } from "./serviceCaseStudies";

const ServiceCaseStudyPage = () => {
  const { slug } = useParams();
  const study = slug ? CASE_STUDIES_BY_SLUG[slug] : null;
  const [markdown, setMarkdown] = useState("");

  useEffect(() => {
    if (!study) return;
    fetchAndDisplayText(study.markdownUrl, setMarkdown);
  }, [study]);

  if (!study) {
    return <Navigate to="/services" replace />;
  }

  const topicHref = `/services#${study.topicAnchor}`;

  return (
    <>
      <nav className="services-breadcrumb" aria-label="Breadcrumb">
        <Link to="/services">Services</Link>
        <span className="services-breadcrumb-sep" aria-hidden="true">
          /
        </span>
        <span>Case studies</span>
        <span className="services-breadcrumb-sep" aria-hidden="true">
          /
        </span>
        <span className="services-breadcrumb-current">{study.title}</span>
      </nav>

      <section className="contentBox">
        <p className="services-case-study-meta">
          <Link to={topicHref}>← Back to {study.topicLabel}</Link>
          {" · "}
          <Link to="/services">All services</Link>
        </p>
        {markdown ? (
          <div className="services-markdown services-case-study-body">
            <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
              {markdown}
            </ReactMarkdown>
          </div>
        ) : null}
      </section>
    </>
  );
};

export default ServiceCaseStudyPage;
